// @flow

import ColumnRenderer from "@/utils/JsonPageRenderer/ColumnRenderer";
import ContinueLinkRenderer from "@/utils/JsonPageRenderer/ContinueLinkRenderer";
import ImageRenderer from "@/utils/JsonPageRenderer/ImageRenderer";
import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import RowRenderer from "@/utils/JsonPageRenderer/RowRenderer";
import SectionRenderer from "@/utils/JsonPageRenderer/SectionRenderer";
import SliderRenderer from "@/utils/JsonPageRenderer/SliderRenderer";
import TextRenderer from "@/utils/JsonPageRenderer/TextRenderer";
import VideoPlayerRenderer from "@/utils/JsonPageRenderer/VideoPlayerRenderer";

JsonPageRenderer.register(new SectionRenderer());
JsonPageRenderer.register(new RowRenderer());
JsonPageRenderer.register(new ColumnRenderer());
JsonPageRenderer.register(new TextRenderer());
JsonPageRenderer.register(new ImageRenderer());
JsonPageRenderer.register(new SliderRenderer());
JsonPageRenderer.register(new ContinueLinkRenderer());
JsonPageRenderer.register(new VideoPlayerRenderer());

export { default as TreeBuilder } from "./TreeBuilder";

export default JsonPageRenderer;
